import React from 'react';
import { initialFingers } from '../BiometricComponent/Model';
const initialManos = {
	izquierda: { ...initialFingers },
	derecha: { ...initialFingers }
};
const Hands = ({
	manos = initialManos,
	onClickDedo,
	type_biometric,
	disabled
}) => {
	const classNameState = [
		'hand-finger-path',
		'hand-finger-path-selected',
		'hand-finger-path-capturing',
		'hand-finger-path-captured'
	];

	const onClick = (mano, dedo) => {
		if (!disabled) {
			if (type_biometric === 2) {
				onClickDedo(
					mano,
					dedo,
					dedo === 'pulgar' ? 'P' : mano === 'derecha' ? '4D' : '4I'
				);
			} else {
				onClickDedo(mano, dedo);
			}
		}
	};

	return (
		<svg
			id="ico_hands"
			width="576.39185"
			height="324.28528"
			viewBox="0 0 576.39186 324.28528"
		>
			<g
				id="ico_hand_left_normal_g"
				className={disabled ? 'g-hand-disabled' : ''}
				transform="translate(-433,-248.85627)"
			>
				<path
					id="hand_left_shape"
					data-name="hand_left_shape"
					d="m 22.19,40.163 a 22,22 0 0 1 11.369,3.231 22.174,22.174 0 0 1 22.1,-20.648 21.951,21.951 0 0 1 11.206,3.154 v -3.7 a 22.1945,22.1945 0 0 1 44.389,0 v 3.719 a 21.957,21.957 0 0 1 11.219,-3.155 22.232,22.232 0 0 1 22.208,22.207 v 95.061 l 17.329,-18.087 a 34.456,34.456 0 0 1 37.285,-8.352 17.011,17.011 0 0 1 6.3,27.542 l -8.609,9.137 a 51.771,51.771 0 0 0 -11.941,20.856 62.668,62.668 0 0 1 -38.481,41.131 10.566,10.566 0 0 0 -6.912,9.885 v 43.289 a 5.493,5.493 0 0 1 -5.492,5.494 H 27.018 a 5.493,5.493 0 0 1 -5.494,-5.492 v -28.77 A 39.39,39.39 0 0 0 12.078,211.085 50.407,50.407 0 0 1 0,178.367 v -116 a 22.193,22.193 0 0 1 22.186,-22.2 v 0 z M 133.7,148.208 133.692,44.972 a 11.219,11.219 0 1 0 -22.438,0 v 75.8 a 5.4945,5.4945 0 1 1 -10.989,0 V 22.2 A 11.206001,11.206001 0 1 0 77.854,21.988 c 0,0.071 0,0.141 0,0.212 v 98.571 a 5.495,5.495 0 0 1 -10.989,0 V 44.944 a 11.237,11.237 0 0 0 -22.473,0 v 75.821 a 5.495,5.495 0 0 1 -10.989,0 v -58.4 a 11.21,11.21 0 0 0 -22.419,0 v 116 a 39.37,39.37 0 0 0 9.446,25.58 50.423,50.423 0 0 1 12.076,32.715 v 23.274 h 96.147 v -37.8 a 21.6,21.6 0 0 1 14.121,-20.209 51.624,51.624 0 0 0 31.707,-33.888 62.716,62.716 0 0 1 14.489,-25.306 l 8.609,-9.142 a 6.016,6.016 0 0 0 -2.225,-9.747 23.49,23.49 0 0 0 -25.411,5.7 L 143.154,157.5 c -0.017,0.017 -0.032,0.022 -0.049,0.039"
					transform="translate(433,249)"
					fill="#3e3f43"
				/>
				<g id={type_biometric === 2 && 'hand-section-4I'}>
					<path
						id="hand_left_indice"
						name="left_indice"
						onClick={() => {
							onClick('izquierda', 'indice');
						}}
						className={classNameState[manos.izquierda.indice]}
						data-name="hand_left_indice"
						d="m 133.693,44.972 a 11.219,11.219 0 1 0 -22.438,0 v 75.8 H 133.7 Z"
						transform="translate(433,249)"
						fill="#0db944"
					/>
					<path
						id="hand_left_medio"
						name="left_medio"
						onClick={() => {
							onClick('izquierda', 'medio');
						}}
						className={classNameState[manos.izquierda.medio]}
						data-name="hand_left_medio"
						d="M 100.266,120.772 V 22.2 A 11.206001,11.206001 0 1 0 77.855,21.988 c 0,0.071 0,0.141 0,0.212 v 98.571 h 22.411 z"
						transform="translate(433,249)"
						fill="#0db944"
					/>
					<path
						id="hand_left_menique"
						name="left_menique"
						onClick={() => {
							onClick('izquierda', 'menique');
						}}
						className={classNameState[manos.izquierda.menique]}
						data-name="hand_left_menique"
						d="M 33.4,120.772 V 62.365 a 11.21,11.21 0 0 0 -22.419,0 v 58.407 z"
						transform="translate(433,249)"
						fill="#0db944"
					/>
					<path
						id="hand_left_anular"
						name="left_anular"
						onClick={() => {
							onClick('izquierda', 'anular');
						}}
						className={classNameState[manos.izquierda.anular]}
						data-name="hand_left_anular"
						d="m 66.866,120.772 v 0 -75.828 a 11.237,11.237 0 0 0 -22.473,0 v 75.828 z"
						transform="translate(433,249)"
						fill="#0db944"
					/>
				</g>
				<path
					id="hand_left_pulgar"
					name="left_pulgar"
					onClick={() => {
						onClick('izquierda', 'pulgar');
					}}
					className={
						type_biometric === 2
							? `${classNameState[manos.izquierda.pulgar]}-invalidated`
							: classNameState[manos.izquierda.pulgar]
					}
					data-name="hand_left_pulgar"
					d="m 198.059,125.083 a 6.07,6.07 0 0 0 -1.995,-1.241 23.875,23.875 0 0 0 -25.653,5.7 l -26.692,27.594 v 44.5 a 51.806,51.806 0 0 0 31.274,-33.6 62.589,62.589 0 0 1 14.627,-25.306 l 8.691,-9.142 a 5.977,5.977 0 0 0 -0.251,-8.506"
					transform="translate(432.469,249)"
					fill="#0db944"
				/>
			</g>

			<path
				id="hands_divider"
				fill="none"
				stroke="#E3E3E3"
				d="M 285.65737,19.272001 V 324.28528"
			/>
			<g
				id="ico_hand_right_normal_g"
				className={disabled ? 'g-hand-disabled' : ''}
				transform="translate(-357.08317,-248.85602)"
			>
				<path
					id="hand_right_shape"
					data-name="hand_right_shape"
					d="m 478.284,40.167 h 0.005 a 22.193,22.193 0 0 1 22.186,22.2 v 116 a 50.407,50.407 0 0 1 -12.075,32.718 39.39,39.39 0 0 0 -9.446,25.58 v 28.77 a 5.493,5.493 0 0 1 -5.494,5.492 H 366.316 a 5.493,5.493 0 0 1 -5.492,-5.494 v -43.289 a 10.566,10.566 0 0 0 -6.912,-9.885 62.669,62.669 0 0 1 -38.481,-41.131 51.771,51.771 0 0 0 -11.941,-20.856 l -8.609,-9.137 a 17.011,17.011 0 0 1 6.3,-27.542 34.456,34.456 0 0 1 37.285,8.352 L 355.8,140.032 V 44.971 A 22.231,22.231 0 0 1 378,22.764 21.957,21.957 0 0 1 389.219,25.919 V 22.2 a 22.195,22.195 0 1 1 44.389,0 v 3.7 a 21.951,21.951 0 0 1 11.206,-3.154 22.174,22.174 0 0 1 22.1,20.648 22,22 0 0 1 11.369,-3.231 z M 357.371,157.539 c -0.017,-0.017 -0.032,-0.022 -0.049,-0.039 l -26.789,-27.958 a 23.49,23.49 0 0 0 -25.411,-5.7 6.016,6.016 0 0 0 -2.225,9.747 l 8.609,9.142 a 62.716,62.716 0 0 1 14.489,25.306 51.624,51.624 0 0 0 31.705,33.888 21.6,21.6 0 0 1 14.121,20.209 v 37.8 H 467.97 V 236.66 a 50.423,50.423 0 0 1 12.075,-32.715 39.37,39.37 0 0 0 9.446,-25.58 v -116 a 11.21,11.21 0 0 0 -22.419,0 v 58.4 a 5.4945,5.4945 0 0 1 -10.989,0 V 44.944 a 11.237,11.237 0 0 0 -22.473,0 v 75.827 a 5.4945,5.4945 0 0 1 -10.989,0 V 22.2 c 0,-0.071 0,-0.141 0,-0.212 A 11.206001,11.206001 0 1 0 400.21,22.2 v 98.572 a 5.4945,5.4945 0 0 1 -10.989,0 v -75.8 a 11.219,11.219 0 0 0 -22.438,0 l -0.008,103.236"
					transform="translate(433,249)"
					fill="#3e3f43"
				/>
				<g id={type_biometric === 2 && 'hand-section-4D'}>
					<path
						id="hand_right_indice"
						name="right_indice"
						onClick={() => {
							onClick('derecha', 'indice');
						}}
						className={classNameState[manos.derecha.indice]}
						data-name="hand_right_indice"
						d="m 366.783,44.972 a 11.219,11.219 0 0 1 22.438,0 v 75.8 h -22.444 z"
						transform="translate(433,249)"
						fill="#555555"
					/>
					<path
						id="hand_right_medio"
						name="right_medio"
						onClick={() => {
							onClick('derecha', 'medio');
						}}
						className={classNameState[manos.derecha.medio]}
						data-name="hand_right_medio"
						d="M 400.21,120.772 V 22.2 a 11.206001,11.206001 0 1 1 22.411,-0.212 c 0,0.071 0,0.141 0,0.212 v 98.571 H 400.21 Z"
						transform="translate(433,249)"
						fill="#0db944"
					/>
					<path
						id="hand_right_menique"
						name="right_menique"
						onClick={() => {
							onClick('derecha', 'menique');
						}}
						className={classNameState[manos.derecha.menique]}
						data-name="hand_right_menique"
						d="M 467.072,120.772 V 62.365 a 11.21,11.21 0 0 1 22.419,0 v 58.407 z"
						transform="translate(433,249)"
						fill="#0db944"
					/>
					<path
						id="hand_right_anular"
						name="right_anular"
						onClick={() => {
							onClick('derecha', 'anular');
						}}
						className={classNameState[manos.derecha.anular]}
						data-name="hand_right_anular"
						d="m 433.61,120.772 v 0 -75.828 a 11.237,11.237 0 0 1 22.473,0 v 75.828 z"
						transform="translate(433,249)"
						fill="#0db944"
					/>
				</g>
				<path
					id="hand_right_pulgar"
					name="right_pulgar"
					onClick={() => {
						onClick('derecha', 'pulgar');
					}}
					className={
						type_biometric === 2
							? `${classNameState[manos.derecha.pulgar]}-invalidated`
							: classNameState[manos.derecha.pulgar]
					}
					data-name="hand_right_pulgar"
					d="m 302.944,125.083 a 6.052,6.052 0 0 1 1.99,-1.241 23.77,23.77 0 0 1 25.587,5.7 l 26.623,27.594 v 44.5 a 51.752,51.752 0 0 1 -31.193,-33.6 62.628,62.628 0 0 0 -14.59,-25.306 l -8.669,-9.142 a 5.988,5.988 0 0 1 0.251,-8.506"
					transform="translate(433,249)"
					fill="#0db944"
				/>
			</g>

			<g
				id={type_biometric === 2 && 'hand-section-P'}
				className={disabled ? 'g-hand-disabled' : ''}
			>
				<path
					id="pulgares_left"
					name="pulgar_1"
					onClick={() => {
						onClick('izquierda', 'pulgar');
					}}
					className={classNameState[manos.izquierda.pulgar]}
					data-name="pulgares_left"
					d="m 198.059,125.083 a 6.07,6.07 0 0 0 -1.995,-1.241 23.875,23.875 0 0 0 -25.653,5.7 l -26.692,27.594 v 44.5 a 51.806,51.806 0 0 0 31.274,-33.6 62.589,62.589 0 0 1 14.627,-25.306 l 8.691,-9.142 a 5.977,5.977 0 0 0 -0.251,-8.506"
					transform="translate(-0.531,0.14373)"
					fill="#0db944"
				/>
				<path
					id="pulgares_right"
					name="pulgar_2"
					onClick={() => {
						onClick('derecha', 'pulgar');
					}}
					className={classNameState[manos.derecha.pulgar]}
					data-name="pulgares_right"
					d="m 302.944,125.083 a 6.052,6.052 0 0 1 1.99,-1.241 23.77,23.77 0 0 1 25.587,5.7 l 26.623,27.594 v 44.5 a 51.752,51.752 0 0 1 -31.193,-33.6 62.628,62.628 0 0 0 -14.59,-25.306 l -8.669,-9.142 a 5.988,5.988 0 0 1 0.251,-8.506"
					transform="translate(75.91683,0.14398)"
					fill="#0db944"
				/>
			</g>
		</svg>
	);
};

export default Hands;
